if (!customElements.get('product-details-accordion')) {
  class ProductDetailsAccordion extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const toggle = event.target.closest('[data-accordion-toggle]');
      if (!toggle || !this.contains(toggle)) return;

      const item = toggle.closest('[data-accordion-item]');
      if (!item) return;

      const willOpen = !item.classList.contains('is-open');
      this.querySelectorAll('[data-accordion-item]').forEach((other) => {
        if (other !== item) this.setOpen(other, false);
      });
      this.setOpen(item, willOpen);
    };

    setOpen(item, open) {
      const toggle = item.querySelector('[data-accordion-toggle]');
      const panel = item.querySelector('[data-accordion-panel]');
      const icon = item.querySelector('[data-accordion-icon]');
      if (!toggle || !panel) return;

      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
      if (icon) icon.textContent = open ? '\u2013' : '+';
    }
  }

  customElements.define('product-details-accordion', ProductDetailsAccordion);
}
